function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.059 3.5a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-3 0l-.001-.149-5.374 6.139a1.5 1.5 0 0 1-.956.501l-.156.009a1.498 1.498 0 0 1-1.108-.448l-1.862-1.879-5.934 6.8a1.5 1.5 0 0 1-1.294.554l-.148-.02a1.5 1.5 0 0 1-.823-2.496l7-8a1.5 1.5 0 0 1 2.183-.08l1.941 1.873L17.632 6.5h-.573a1.5 1.5 0 0 1-1.493-1.356L15.559 5a1.5 1.5 0 0 1 1.5-1.5z",
  fill: "#202124",
  fillRule: "nonzero"
});

var SvgIconStats = function SvgIconStats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-stats.a613cbfb.svg";
export { ForwardRef as ReactComponent };